import { render, staticRenderFns } from "./NavigationForm.vue?vue&type=template&id=20ac36d4&scoped=true&"
import script from "./NavigationForm.vue?vue&type=script&lang=js&"
export * from "./NavigationForm.vue?vue&type=script&lang=js&"
import style0 from "./NavigationForm.vue?vue&type=style&index=0&id=20ac36d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ac36d4",
  null
  
)

export default component.exports